var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#0079c1",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1",
    values: "10;0",
    keyTimes: "0;1",
    calcMode: "spline",
    dur: "1.5625s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "#0079c1;#49a942;#00a0af;#49176d;#0079c1",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "discrete",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#0079c1",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#49176d",
    r: 10,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-1.5625s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-1.5625s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#00a0af",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-3.125s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-3.125s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#49a942",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-4.6875s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-4.6875s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "6.25s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.4e3affefe7c4739ecbbc0e076b16fd6d.svg";
export { ForwardRef as ReactComponent };